/* Run something once the document has its elements.
   =================================================

   THIS IS THE PIECE THAT MAKES DOM CODE MOVABLE, and it exists because of a
   trap that would have been silent.

   Code that lives inline near the bottom of app.html runs after the markup
   above it exists, so it can call getElementById and get an element. The same
   code in the bundle runs from <head>, before any of that markup is parsed —
   so every lookup returns null.

   The share dialog opens with `const dlg = $('sh-dlg'); if (!dlg) return;`.
   Moved as-is, that guard would fire on every page load and sharing would
   simply stop working: no error, no warning, nothing in the console. A feature
   would just quietly not be there.

   So anything extracted from app.html that touches the DOM gets wrapped in
   this. It runs immediately if the document is already parsed, and on
   DOMContentLoaded if not, so it behaves the same whether the bundle is in
   <head> or moved later.
*/

export function onReady(fn) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fn, { once: true });
  } else {
    // Already parsed — run now rather than waiting for an event that has been
    // and gone, which would never fire and would look exactly like the bug
    // this function exists to prevent.
    fn();
  }
}
